<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="900"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :validate="validateInfos.title"
          v-model:value="modelRef.title"
        />

        <e-input
          title="短标题"
          :validate="validateInfos.subTitle"
          v-model:value="modelRef.subTitle"
        />

        <e-tree-select
          title="分类"
          :fieldNames="replaceFields"
          :validate="validateInfos.goodsCategoryId"
          v-model:value="modelRef.goodsCategoryId"
          :options="treeData"
        />

        <e-input-upload title="缩略图" v-model:value="modelRef.pic" />
        <e-choose-images title="Banner图" v-model:value="banners" />

        <e-input title="单位" v-model:value="modelRef.unit" :valueCol="6" />
        <e-input title="规格" v-model:value="modelRef.specification" :valueCol="6" />

        <e-input-number title="原价" v-model:value="modelRef.sellingPrice" :labelCol="4" />
        <e-input-number title="售价" v-model:value="modelRef.promotionPrice" :labelCol="4" />

        <e-radio
          title="状态"
          v-model:value="modelRef.isSelling"
          :options="$store.state.app.isSelling"
        />

        <e-textarea
          title="备注"
          v-model:value="modelRef.remark"
        />

        <e-editor ref="editor" title="内容" :validate="validateInfos.content" v-model:value="modelRef.content" />

      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { GoodsClass } from '@/apis/goods'
import { dataToTree } from '@/utils'
import dayjs from 'dayjs'

const useForm = Form.useForm
const api = new GoodsClass()
export default defineComponent({
  components: {

  },
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    const replaceFields = {
      label: 'title',
      value: 'id'
    }
    const treeData = ref([])
    const banners = ref([])

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      replaceFields,
      treeData,
      banners,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.title = formData.title
        this.modelRef.subTitle = formData.subTitle
        this.modelRef.isSelling = formData.isSelling
        this.modelRef.pic = formData.pic
        this.modelRef.banner = formData.banner
        this.modelRef.content = formData.content
        this.modelRef.stockPrice = formData.stockPrice
        this.modelRef.sellingPrice = formData.sellingPrice
        this.modelRef.promotionPrice = formData.promotionPrice
        this.modelRef.quantity = formData.quantity
        this.modelRef.unit = formData.unit
        this.modelRef.specification = formData.specification
        this.modelRef.brand = formData.brand
        this.modelRef.remark = formData.remark
        this.modelRef.goodsCategoryId = formData.goodsCategoryId

        this.modelRef.id = formData.id
        this.banners = formData.banner ? formData.banner.split(',') : []

        this.$refs.editor.setHtml(formData.content)

        this.title = '编辑：' + formData.title
        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)

        this.modelRef.publishTime = dayjs()
        this.title = '添加服务'

        this.$refs.editor.setHtml('')
        this.isEdit = false
      }

      this.getTypes()
      this.visible = true
    },

    async getTypes () {
      const list =
        this.$store.state.data.ALL_GOODSCATEGORYS.length > 0
          ? this.$store.state.data.ALL_GOODSCATEGORYS
          : await this.$store.dispatch('GetAllGoodsCategorys')

      const data = dataToTree(list, 0)
      this.treeData = data
    },

    onSubmitFun (e) {
      const data = toRaw(e)

      data.banner = this.banners.join(',')

      if (this.isEdit) {
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok', data)
          this.onClose()
        })
      } else {
        delete data.id
        api.create(data).then(() => {
          this.loading = false
          this.$message.success('添加成功')
          this.$emit('ok', data)
          this.onClose()
        })
      }
    }
  }
})
</script>
